import { BifrostBackendApi } from "../gateways/BifrostBackendApi.js";
import { store } from "../store";
import appConfig from "../appconfig";

// Bilka NY
// const mockData = {
// 	1651: {
// 		shopName: "Bilka Tilst",
// 		"00000000-0000-0000-0000-000000000120": [
// 			{
// 				totalQuantity: 47,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 23,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 87,
// 				intervalIndex: 2
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000121": [
// 			{
// 				totalQuantity: 71,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 54,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 19,
// 				intervalIndex: 2
// 			}
// 		]
// 	},
// 	1652: {
// 		shopName: "Bilka Skalborg",
// 		"00000000-0000-0000-0000-000000000120": [
// 			{
// 				totalQuantity: 76,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 33,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 58,
// 				intervalIndex: 2
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000121": [
// 			{
// 				totalQuantity: 64,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 90,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 48,
// 				intervalIndex: 2
// 			}
// 		]
// 	},
// 	1653: {
// 		shopName: "Bilka Waves, Hundige",
// 		"00000000-0000-0000-0000-000000000120": [
// 			{
// 				totalQuantity: 21,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 79,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 62,
// 				intervalIndex: 2
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000121": [
// 			{
// 				totalQuantity: 85,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 39,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 74,
// 				intervalIndex: 2
// 			}
// 		]
// 	}
// };
// Foetex NY
// const mockData = {
// 	1201: {
// 		shopName: "føtex Food Bella",
// 		"00000000-0000-0000-0000-000000000120": [
// 			{
// 				totalQuantity: 4,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 5,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 6,
// 				intervalIndex: 2
// 			}
// 		],
// 		"365314d2-9be3-4317-a017-9c45fdc4b6a6": [
// 			{
// 				totalQuantity: 7,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 8,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 9,
// 				intervalIndex: 2
// 			}
// 		]
// 	},
// 	1203: {
// 		shopName: "føtex Food Frederiks Allé",
// 		"00000000-0000-0000-0000-000000000120": [
// 			{
// 				totalQuantity: 9,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 8,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 7,
// 				intervalIndex: 2
// 			}
// 		],
// 		"365314d2-9be3-4317-a017-9c45fdc4b6a6": [
// 			{
// 				totalQuantity: 6,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 5,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 4,
// 				intervalIndex: 2
// 			}
// 		]
// 	},
// 	1204: {
// 		shopName: "føtex Food Guldsmedgade",
// 		"00000000-0000-0000-0000-000000000120": [
// 			{
// 				totalQuantity: 60,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 50,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 40,
// 				intervalIndex: 2
// 			}
// 		],
// 		"365314d2-9be3-4317-a017-9c45fdc4b6a6": [
// 			{
// 				totalQuantity: 30,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 20,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 10,
// 				intervalIndex: 2
// 			}
// 		]
// 	},
// 	1207: {
// 		shopName: "føtex Faaborg",
// 		"00000000-0000-0000-0000-000000000120": [
// 			{
// 				totalQuantity: 99,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 22,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 11,
// 				intervalIndex: 2
// 			}
// 		],
// 		"365314d2-9be3-4317-a017-9c45fdc4b6a6": [
// 			{
// 				totalQuantity: 33,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 44,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 55,
// 				intervalIndex: 2
// 			}
// 		]
// 	}
// };
// Foetex Mortensaften
// const mockData = {
// 	"1303": {
// 		"shopName": "føtex Brønderslev",
// 		"00000000-0000-0000-0000-000000000202": [
// 			{
// 				"totalQuantity": 11,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"8f824498-4a13-4977-9109-05b2ec2ec03d": [
// 			{
// 				"totalQuantity": 33,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"70259def-0a0b-411a-b1ae-bab58292247d": [
// 			{
// 				"totalQuantity": 55,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000201": [
// 			{
// 				"totalQuantity": 33,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000203": [
// 			{
// 				"totalQuantity": 55,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"6f0a6b42-764d-4fd5-9ea6-eef14e02d58e": [
// 			{
// 				"totalQuantity": 11,
// 				"intervalIndex": 0
// 			}
// 		]
// 	},
// 	"1308": {
// 		"shopName": "føtex Silkeborg, Torvet",
// 		"8f824498-4a13-4977-9109-05b2ec2ec03d": [
// 			{
// 				"totalQuantity": 4,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"6f0a6b42-764d-4fd5-9ea6-eef14e02d58e": [
// 			{
// 				"totalQuantity": 4,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"70259def-0a0b-411a-b1ae-bab58292247d": [
// 			{
// 				"totalQuantity": 4,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000201": [
// 			{
// 				"totalQuantity": 14,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000202": [
// 			{
// 				"totalQuantity": 14,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000203": [
// 			{
// 				"totalQuantity": 1,
// 				"intervalIndex": 0
// 			}
// 		]
// 	}
// };

// Foetex Juleaften / Christmas
// const mockData = {
// 	1204: {
// 		shopName: "føtex Food Bella",
// 		"8f824498-4a13-4977-9109-05b2ec2ec03d": [
// 			{
// 				totalQuantity: 10,
// 				intervalIndex: 0
// 			}
// 		],
// 		"6f0a6b42-764d-4fd5-9ea6-eef14e02d58e": [
// 			{
// 				totalQuantity: 20,
// 				intervalIndex: 0
// 			}
// 		],
// 		"70259def-0a0b-411a-b1ae-bab58292247d": [
// 			{
// 				totalQuantity: 3,
// 				intervalIndex: 0
// 			}
// 		],
// 		"e3d2fc40-4033-4722-997d-073a81fddc9e": [
// 			{
// 				totalQuantity: 4,
// 				intervalIndex: 0
// 			}
// 		]
// 	},
// 	1207: {
// 		shopName: "føtex Food Frederiks Allé",
// 		"8f824498-4a13-4977-9109-05b2ec2ec03d": [
// 			{
// 				totalQuantity: 1,
// 				intervalIndex: 0
// 			}
// 		],
// 		"6f0a6b42-764d-4fd5-9ea6-eef14e02d58e": [
// 			{
// 				totalQuantity: 2,
// 				intervalIndex: 0
// 			}
// 		],
// 		"70259def-0a0b-411a-b1ae-bab58292247d": [
// 			{
// 				totalQuantity: 3,
// 				intervalIndex: 0
// 			}
// 		],
// 		"e3d2fc40-4033-4722-997d-073a81fddc9e": [
// 			{
// 				totalQuantity: 4,
// 				intervalIndex: 0
// 			}
// 		]
// 	},
// 	1301: {
// 		shopName: "føtex Food Guldsmedgade",
// 		"8f824498-4a13-4977-9109-05b2ec2ec03d": [
// 			{
// 				totalQuantity: 11,
// 				intervalIndex: 0
// 			}
// 		],
// 		"6f0a6b42-764d-4fd5-9ea6-eef14e02d58e": [
// 			{
// 				totalQuantity: 22,
// 				intervalIndex: 0
// 			}
// 		],
// 		"70259def-0a0b-411a-b1ae-bab58292247d": [
// 			{
// 				totalQuantity: 33,
// 				intervalIndex: 0
// 			}
// 		],
// 		"e3d2fc40-4033-4722-997d-073a81fddc9e": [
// 			{
// 				totalQuantity: 44,
// 				intervalIndex: 0
// 			}
// 		]
// 	},
// 	1302: {
// 		shopName: "føtex Faaborg",
// 		"8f824498-4a13-4977-9109-05b2ec2ec03d": [
// 			{
// 				totalQuantity: 99,
// 				intervalIndex: 0
// 			}
// 		],
// 		"6f0a6b42-764d-4fd5-9ea6-eef14e02d58e": [
// 			{
// 				totalQuantity: 88,
// 				intervalIndex: 0
// 			}
// 		],
// 		"70259def-0a0b-411a-b1ae-bab58292247d": [
// 			{
// 				totalQuantity: 77,
// 				intervalIndex: 0
// 			}
// 		],
// 		"e3d2fc40-4033-4722-997d-073a81fddc9e": [
// 			{
// 				totalQuantity: 66,
// 				intervalIndex: 0
// 			}
// 		]
// 	}
// };

// Bilka Juleaften / Christmas
// const mockData = {
// 	1651: {
// 		shopName: "Bilka Tilst",
// 		"00000000-0000-0000-0000-000000000101": [
// 			{
// 				totalQuantity: 10,
// 				intervalIndex: 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000103": [
// 			{
// 				totalQuantity: 20,
// 				intervalIndex: 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000102": [
// 			{
// 				totalQuantity: 30,
// 				intervalIndex: 0
// 			}
// 		],
// 		"f157bb13-4767-44ca-b0fc-eeda263b8590": [
// 			{
// 				totalQuantity: 40,
// 				intervalIndex: 0
// 			}
// 		]
// 	},
// 	1652: {
// 		shopName: "Bilka Skalborg",
// 		"00000000-0000-0000-0000-000000000101": [
// 			{
// 				totalQuantity: 11,
// 				intervalIndex: 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000103": [
// 			{
// 				totalQuantity: 22,
// 				intervalIndex: 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000102": [
// 			{
// 				totalQuantity: 33,
// 				intervalIndex: 0
// 			}
// 		],
// 		"f157bb13-4767-44ca-b0fc-eeda263b8590": [
// 			{
// 				totalQuantity: 44,
// 				intervalIndex: 0
// 			}
// 		]
// 	},
// 	1653: {
// 		shopName: "Bilka Waves, Hundige",
// 		"00000000-0000-0000-0000-000000000101": [
// 			{
// 				totalQuantity: 12,
// 				intervalIndex: 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000103": [
// 			{
// 				totalQuantity: 13,
// 				intervalIndex: 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000102": [
// 			{
// 				totalQuantity: 14,
// 				intervalIndex: 0
// 			}
// 		],
// 		"f157bb13-4767-44ca-b0fc-eeda263b8590": [
// 			{
// 				totalQuantity: 15,
// 				intervalIndex: 0
// 			}
// 		]
// 	}
// };

const ProductOrderCountProvider = {
	async findProductOrderCount(shopId = "") {
		const queryData = {};
		if (shopId) {
			queryData.shopId = shopId;
		}
		const result = await BifrostBackendApi.get("/product-order-count", {
			headers: { Authorization: store.getters.jwtToken },
			params: queryData
		});

		return result.data;
	},
	// async findProductIntervalCount() {
	// 	return mockData;
	// },
	async findProductIntervalCount({ productIds, intervals }) {
		const queryData = {
			productIds,
			intervals,
			tenantId: appConfig.tenantId
		};
		const result = await BifrostBackendApi.get("/product-monitoring", {
			headers: { Authorization: store.getters.jwtToken },
			params: queryData
		});

		return result.data;
	}
};

export default Object.freeze(ProductOrderCountProvider);
